import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useStyles } from "../../styles";
import { useTranslation } from "react-i18next";
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper";
import { reportFolioServices } from "../../../../../../../../../../utils/constants/callService";
import { ConfirmModal } from "../ConfirmModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SnackSimple } from "../../../../../../../../../../components";
import { Types } from "../../../../../../../../../../utils/enums/types";
import format from "date-fns/format";
import es from "date-fns/locale/es";
import { icons } from "../../../../../../../../../../utils/icons";
import { Constants } from "../../../../../../../../../../utils/constants";
import { AnswerTypeHistory } from "../../../../enums/answerType";

interface UserAssign {
  id: number;
  firstName: string;
  lastName: string;
}

interface RequestCuoteInterface {
  items: Array<{
    id: number;
    type: string;
    dateRequestCreateFolio: string;
    usersAssings: UserAssign[];
    userManageDepartment: number;
    newStep: string;
    typeHistory: string;
    requestSubmitted: boolean
    dateRequestQuote:string;
  }>;
  reload: () => void;
  left: any
  disabled:boolean
}

export const RequestCuote = ({ items, reload, left,disabled }: RequestCuoteInterface) => {
  const styles = useStyles();
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation();
  const { id: reportFolioId } = useParams<{ id: string }>();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [alertModals, setAlertModals] = useState(false);
  const [messageAlertModals, setMessageAlertModals] = useState("");
  const lastRequestQuote = items
    ?.filter((item) => item.type === AnswerTypeHistory.REQUEST_QUOTES)
    .sort((a, b) => a.index - b.index)
    .at(0);

  const provider =
    lastRequestQuote?.usersAssings?.[0]
      ? `${lastRequestQuote.usersAssings[0].firstName} ${lastRequestQuote.usersAssings[0].lastName}`
      : t("reportFolio.detail.general.noAssignedUser");

  const formattedDate = lastRequestQuote?.dateRequestQuote
    ? format(new Date(lastRequestQuote.dateRequestQuote), Constants.dateFormatGeneral3, { locale: es })
    : t("reportFolio.detail.general.noDateAvailable");

  const isSubmitted = lastRequestQuote?.requestSubmitted

  const handleConfirm = async () => {
    if (!lastRequestQuote?.usersAssings?.[0]?.id || !reportFolioId) return;

    const payload = {
      reportFolioId: Number(reportFolioId),
      description: "", // Enviar descripción vacía
      userReviewer: lastRequestQuote.usersAssings[0].id,
    };

    setSubmitting(true);

    try {
      const response = await reportFolioServices.requestQuote(payload);
      if (response.code === "00") {
        setMessageAlertModals(t("reportFolio.detail.general.confirmQuotationTitleSucces"));
        setAlertModals(true); // Muestra el snackbar
        setModalOpen(false);
      } else {
        setMessageAlertModals(t("reportFolio.detail.general.confirmQuotationTitleError"));
        setAlertModals(true); // Muestra el snackbar
        setModalOpen(false);
      }
    } catch (error) {
      console.error("Error al enviar la solicitud:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseAlertsModal = () => {
    setAlertModals(false); // Oculta el snackbar
  };

  const handleReassing = () => {
    const stateNavigation = {
      state: {
        ...location.state,
        replaceRoutes: {
          ...location?.state?.replaceRoutes ?? {},
          folio_detail: {
            search: location?.search,
            state: location?.state
          }
        }
      }
    }
    navigate(`/dashboard/report-folio/dashboard/detail/reassign-user/${reportFolioId}`, stateNavigation)
  }

  return (
    <>
      <CustomPaper sx={styles.userContainer} elevation={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* Sección del texto */}
          <Box>
            <Typography sx={styles.title(2)}>
              {isSubmitted ? (
                <Box display="flex" alignItems="center">
                  {icons("info")}
                  <span style={{ marginLeft: '8px' }}>
                    {t("reportFolio.detail.general.quotationTitleProviderSend")}
                  </span>
                </Box>
              ) : (
                t("reportFolio.detail.general.quotationTitle")
              )}
            </Typography>

            <Typography variant="body2">
              {isSubmitted ?
                t("reportFolio.detail.general.providerAssignedAndDate", { Date: formattedDate }) :
                t("reportFolio.detail.general.providerAssigned", { provider })}
            </Typography>
          </Box>

          {/* Sección de botones */}
          {!isSubmitted ? (
            <Box display="flex" gap={2}>
              {left?.type !== "preventive" && (
                <Button variant="outlined" color="primary" onClick={handleReassing}>
                  {t("reportFolio.detail.reassignProviderSucces.title")}
                </Button>
              )}
              <Button
                variant="contained"
                onClick={() => setModalOpen(true)}
                disabled={isSubmitting || !lastRequestQuote?.usersAssings?.[0] || disabled}
              >
                {t("reportFolio.detail.general.quotationTitle")}
              </Button>
            </Box>
          ) : <>

          </>}

        </Box>
        {isSubmitted ? (<Box>
          <Typography variant="body1">
            {t("reportFolio.detail.general.quotationSendMessage")}
          </Typography>
        </Box>) : <></>}


      </CustomPaper>

      {/* Confirm Modal */}
      <ConfirmModal
        open={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
        title={t("reportFolio.detail.general.confirmQuotationTitle")}
        description={t("reportFolio.detail.general.confirmQuotationDescription", { provider: provider })}
        /* reload={reload} */
      />

      <SnackSimple
        open={alertModals}
        close={handleCloseAlertsModal}
        message={messageAlertModals}
        type={Types.SUCCESS}
      />
    </>
  );
};